function Pause({ size }: { size: number }) {
  return (
    <svg height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.25 3H5V21H10.25V3Z" fill="currentColor" />
      <path d="M18.5 3H13.25V21H18.5V3Z" fill="currentColor" />
    </svg>
  )
}

export default Pause
